import React, { useState, useRef, useEffect } from 'react';
import { Popup } from '@progress/kendo-react-popup';

import "./IconPickerStyle.css";

export const actionIcons = [
	"far fa-sidebar",
	"far fa-table",
	"far fa-credit-card-blank",
	"far fa-table-columns",
	"far fa-calendar-days",
	"far fa-rectangle-list",
	"far fa-chart-bar",
	"far fa-pen-paintbrush",
	"far fa-chart-user",
	"far fa-arrow-rotate-right",
	"far fa-trash-can",
	"far fa-link",
	"far fa-link-slash",
	"far fa-pen-to-square",
	"far fa-share-from-square",
	"far fa-clone",
	"far fa-copy",
	"far fa-floppy-disk",
	"far fa-square-kanban",
	"far fa-eraser",
	"far fa-chart-mixed",
	"far fa-eye-slash",
	"far fa-print",
	"far fa-file-arrow-down",
	"far fa-file-upload",
	"far fa-box-archive",
	"far fa-hand-holding-heart",
	"far fa-file-export",
	"far fa-file-import",
	"far fa-ellipsis-vertical",
	"far fa-ellipsis",
	"far fa-grip-dots-vertical",
	"far fa-angle-down",
	"far fa-angle-right",
	"far fa-angle-left",
	"far fa-angle-up",
	"far fa-plus",
	"far fa-dash",
	"far fa-xmark",
	"far fa-check",
];

export const icons = [
	"far fa-anchor",
	"far fa-address-card",
	"far fa-user-chart",
	"far fa-paper-plane",
	"far fa-badge-sheriff",
	"far fa-bullseye-arrow",
	"far fa-table",
	"far fa-flag-checkered",
	"far fa-store",
	"far fa-phone-office",
	"far fa-bell",
	"far fa-key",
	"far fa-book",
	"far fa-star",
	"far fa-cart-plus",
	"far fa-user",
	"far fa-calendar",
	"far fa-calendar-alt",
	"far fa-info",
	"far fa-cloud-download",
	"far fa-browser",
	"far fa-computer-speaker",
	"far fa-car-building",
	"far fa-building",
	"far fa-envelope",
	"far fa-person-dolly-empty",
	"far fa-house",
	"far fa-network-wired",
	"far fa-server",
	"far fa-seedling",
	"far fa-object-group",
	"far fa-people-carry",
	"far fa-question",
	"far fa-shipping-fast",
	"far fa-share-alt",
	"far fa-sticky-note",
	"far fa-tags",
	"far fa-toolbox",
	"far fa-tools",
	"far fa-warehouse",
	"far fa-box-open",
	"far fa-receipt",
	"far fa-plane-departure",
	"far fa-map-marked",
	"far fa-music",
	"far fa-globe",
	"far fa-briefcase",
	"far fa-clinic-medical",
	"far fa-radiation-alt",
	"far fa-cubes",
	"far fa-swatchbook",
	"far fa-magic",
	"far fa-image",
	"far fa-phone-volume",
	"far fa-chess-queen-alt",
	"far fa-radar",
	"far fa-file-edit",
	"far fa-file",
	"far fa-gift",
	"far fa-analytics",
	"far fa-poll",
	"far fa-users",
	"far fa-game-console-handheld",
	"far fa-bookmark",
	"far fa-chart-scatter",
	"far fa-fire",
	"far fa-credit-card",
	"far fa-list",
	"far fa-layer-group",
	"far fa-industry",
	"far fa-inventory",
	"far fa-ethernet",
	"far fa-smile",
	"far fa-place-of-worship",
	"far fa-star-of-david",
	"far fa-steering-wheel",
	"far fa-binoculars",
	"far fa-lightbulb",
	"far fa-rabbit-fast",
	"far fa-globe-snow",
	"far fa-folder-open",
	"far fa-folder",
	"far fa-hand-holding-heart",
	"far fa-hourglass-start",
	"far fa-umbrella",
	"far fa-tachometer-alt-slowest",
	"far fa-award",
	"far fa-graduation-cap",
	"far fa-backpack",
	"far fa-address-book",
	"far fa-badge-dollar",
	"far fa-keynote",
	"far fa-money-check-edit",
	"far fa-balance-scale",
	"far fa-bullhorn",
	"far fa-bags-shopping",
	"far fa-laptop-house",
	"far fa-file-chart-line"
];

const IconList = ({ icons, selected, onSelect }) => {
	return (
		<ul className="icon-list">
			{
				icons.map((icon, index) =>
					<li className="icon-list-item">
						<button
							type="button"
							onClick={() => onSelect(icon)}
							className={icon === selected ? "icon-button selected-icon" : "icon-button"}
							key={index}>
							<i className={icon} />
						</button>
					</li>
				)
			}
		</ul>
	);
}

const IconPicker = (props) => {

	const anchor = useRef();
	const popup = useRef();
	const [show, setShow] = useState(false);

	const {
		onChange,
		disabled,
		selected,
		isActionIcon
	} = props;

	function handleChange(icon) {
		onChange(icon);
		setShow(false);
	}

	function handleOutsideClick(e) {
		const { target } = e;

		if (
			anchor &&
			anchor.current &&
			target !== anchor.current &&
			!anchor.current.contains(target) &&
			popup &&
			popup.current &&
			!popup.current.contains(target)
		) {
			setShow(false);
		}
	}

	useEffect(() => {
		document.addEventListener('click', handleOutsideClick);

		return () => {
			document.removeEventListener('click', handleOutsideClick);
		}
	}, []);

	return (
		<div>
			<button
				className="k-button icon-dropdown-anchor"
				style={{ height: 34 }}
				ref={anchor}
				type="button"
				disabled={disabled}
				onClick={() => setShow(!show)}
				data-testid="icon-picker"
			>
				<div data-testid="selected-icon" className="selected-icon">
					<i data-testid="selected-icon-value" className={selected} />
				</div>
				<div className="dropdown-icon">
					<i className="far fa-chevron-down" />
				</div>
			</button>
			<Popup
				animate={false}
				className={isActionIcon? "icon-holder-actions":"icon-holder"} 
				anchor={anchor.current}
				show={show}>
				<div
					ref={popup}>
					<IconList
						selected={selected}
						icons={isActionIcon? actionIcons:icons}
						onSelect={handleChange} />
				</div>
			</Popup>
		</div>
	);
}

export default IconPicker;
